import { PDE } from "../../htttp/urls";

export const postLogIn = async (payload) => {
  const res = await PDE.post("api/v1/login", payload, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
  return res;
};

export const checkSessionAPI = async () => {
  const res = await PDE.get("api/v1/checkSession", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("AdminHeaven")}`,
    },
  });
  return res;
};
